import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IPPPIQDocument } from './types';

const getPPPIQDocuments = async (registrationId: string): Promise<IPPPIQDocument[]> => {
  const response = await configApi.get('registration/registrations-with-pppiq/', {
    params: { registration_id: registrationId },
  });
  const results: { attachments?: IPPPIQDocument[] }[] = response.data?.results ?? [];
  return results.flatMap((r) => r.attachments ?? []);
};

export const useGetPPPIQDocuments = (registrationId: string) => {
  return useQuery({
    queryKey: ['pppiq_documents', registrationId],
    queryFn: () => getPPPIQDocuments(registrationId),
    enabled: !!registrationId,
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};
